import React from 'react'
import {Helmet} from "react-helmet";
import Header from './Headers';
import Footer from '../footer';

const AnnualReturn = () => {
  return (
    <div>
        <Helmet>
            <meta charSet="utf-8"/>
            <meta name="title" content="Electric Three Wheeler and Two wheeler loan"/>
            <meta name="description"
                  content="Revfin offers Electric Vehicle loans to independent electric vehicle drivers."/>
            <meta name="keywords" content="Electric Vehicle loan"/>

        </Helmet>
        <Header/>
        <div className="col-lg-4 col-md-4 col-xs-12 col-sm-6" style={{margin: '130px'}}>
            <div className="pannelgridPat">
                <a href="https://revfin-documents.s3.ap-south-1.amazonaws.com/Annual+Return_Form+MGT-7-2021-22_Revfin.pdf"
                   target="_blank" rel="noopener noreferrer"><h3 className="heading_tow">FY 2021-22</h3></a>
            </div>
        </div>
        <Footer/>
    </div>
  )
}

export default AnnualReturn



// WEBPACK FOOTER //
// ./src/components/annualReturn.jsx